<template>
  <aviso-informativo title="Disponibilidade:" v-if="visivel">
      <div class="produto-disponibilidade-horario" v-if="tabela.turnos">
        Disponível das <b>{{ tabela.turnos }}</b>
      </div>
      <div class="produto-disponibilidade-restricoes" v-if="restricoes.length">
        <div v-for="restricao in restricoes" :key="restricao">
          - {{ restricao }}
        </div>
      </div>
  </aviso-informativo>
</template>

<script>
import AvisoInformativo from './AvisoInformativo';

export default {
  name: 'ProdutoDisponibilidade',
  components: {AvisoInformativo},
  props: {
    tabela: {
      type: Object,
      required: true
    }
  },
  computed: {
    restricoes() {
      const restricoesConsumo = {
        '2': 'Apenas para retiradas',
        '3': 'Apenas para entregas',
        '4': 'Apenas para consumo no local',
        '5': 'Apenas para retiradas ou entregas',
        '6': 'Apenas para retiradas ou consumo no local'
      };
      const restricoesModoPedido = {
        '2': 'Apenas para pedidos agendados',
        '3': 'Apenas para pedidos imediatos'
      };

      return [
        restricoesConsumo[String(this.tabela.tipo_consumo || '1')],
        restricoesModoPedido[String(this.tabela.modo_pedido || '1')]
      ].filter(Boolean);
    },
    visivel() {
      const indisponivel = String(this.tabela.disponivel) === '0';

      return indisponivel && (Boolean(this.tabela.turnos) || this.restricoes.length > 0);
    }
  }
};
</script>

<style scoped>
.produto-disponibilidade-horario {
  margin-top: 2px;
  font-size: 12px;
}

.produto-disponibilidade-restricoes {
  margin-top: 3px;
  font-size: 12px;
  line-height: 1.45;
}
</style>
